import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Grid,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const Sponsormodel = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [wordCount, setWordCount] = useState(0);
  const [wordCountWithoutSpaces, setWordCountWithoutSpaces] = useState(0);

  const handleClose = () => {
    navigate(-1);
  };

  const countWordsWithSpaces = (text) => {
    if (!text.trim()) return 0;
    return text.trim().split(/\s+/).length;
  };

  const countWordsWithoutSpaces = (text) => {
    return text.replace(/\s+/g, "").length;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "message") {
      const words = countWordsWithSpaces(value);
      const wordsWithoutSpaces = countWordsWithoutSpaces(value);

      setWordCount(words);
      setWordCountWithoutSpaces(wordsWithoutSpaces);

      let tempErrors = { ...errors };
      if (words > 300) {
        tempErrors.message = "Message cannot exceed 300 words";
      } else {
        delete tempErrors.message;
      }
      setErrors(tempErrors);
    }
  };

  const validateForm = () => {
    let tempErrors = {};

    if (!formData.firstName.trim() || formData.firstName.trim().length < 2) {
      tempErrors.firstName = "First Name is required";
    }
    if (!formData.lastName.trim() || formData.lastName.trim().length < 2) {
      tempErrors.lastName = "Last Name is required";
    }
    if (!formData.emailAddress.trim()) {
      tempErrors.emailAddress = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.emailAddress)) {
      tempErrors.emailAddress = "Enter a valid email address";
    }
    if (!formData.phone.trim()) {
      tempErrors.phone = "Phone number is required";
    }
    if (wordCount === 0) {
      tempErrors.message = "Message is required";
    } else if (wordCount > 300) {
      tempErrors.message = "Message cannot exceed 300 words";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit1 = async () => {
    if (validateForm() && wordCount <= 300) {
      try {
        const response = await axios.post(
          "https://api.gkaglobal.org/restgka/bs.php",
          {
            mailto: formData.emailAddress,
            firstName: formData.firstName,
            lastName: formData.lastName,
            emailAddress: formData.emailAddress,
            phone: formData.phone,
            message: formData.message,
            subject: "Become Sponsor",
          }
        );
  
  
        if (response.data?.status==="success") {
        
          alert(response.data.message);
          handleClose2();
        } else {
          alert(response.data?.message);
        }


      } catch (error) {
        alert("Error: Unable to send email. Please try again later.");
      }
    }
  };
  
  const handleClose2 = () => {
    setFormData({
      firstName: "",
      lastName: "",
      emailAddress: "",
      phone: "",
      message: "",
    });
    setWordCount(0);
    setWordCountWithoutSpaces(0);
    setErrors({});
  };
  
  

  return (
    <Dialog open={true} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Become A Sponsor
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              placeholder="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              placeholder="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="email"
              fullWidth
              required
              placeholder="Email Address"
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleChange}
              error={!!errors.emailAddress}
              helperText={errors.emailAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="tel"
              fullWidth
              required
              placeholder="Phone No"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={4}
              fullWidth
              placeholder="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              error={!!errors.message}
              helperText={errors.message}
            />
            <Typography
              variant="body2"
              sx={{
                color: wordCount > 300 ? "red" : "gray",
                textAlign: "right",
                marginTop: "4px",
              }}
            >
              {wordCount} words ({wordCountWithoutSpaces} without spaces) / 300
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} sx={{ color: "black" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: wordCount > 300 ? "#ccc" : "#f5951c",
            color: "#FFFFFF",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: wordCount > 300 ? "#ccc" : "black",
            },
          }}
          onClick={handleSubmit1 }
          disabled={wordCount > 300}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Sponsormodel;
